var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9789 5.31349C18.7628 4.51023 18.1295 3.87703 17.3264 3.66074C15.8591 3.25928 9.99 3.25928 9.99 3.25928C9.99 3.25928 4.12113 3.25928 2.65388 3.64552C1.86619 3.86158 1.21742 4.51035 1.00136 5.31349C0.615234 6.78062 0.615234 9.82326 0.615234 9.82326C0.615234 9.82326 0.615234 12.8812 1.00136 14.333C1.21765 15.1362 1.85074 15.7694 2.654 15.9857C4.13658 16.3873 9.99023 16.3873 9.99023 16.3873C9.99023 16.3873 15.8591 16.3873 17.3264 16.001C18.1296 15.7848 18.7628 15.1516 18.9791 14.3485C19.3651 12.8812 19.3651 9.83871 19.3651 9.83871C19.3651 9.83871 19.3806 6.78062 18.9789 5.31349ZM8.12141 12.6342V7.01237L13.0019 9.82326L8.12141 12.6342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6212520e00439a63639c57da7d7522fa.svg";
export { ForwardRef as ReactComponent };